// component
import Iconify from '../../../components/iconify';

const navConfig = [
  {
    title: 'dashboard',
    path: '/dashboard',
    icon: <Iconify icon={'mdi:view-dashboard'} />,
    role: ['admin', 'user'],
  },
  {
    title: 'Contas',
    path: '/accounts',
    icon: <Iconify icon={'mdi:domain'} />,
    role: ['admin'],
  },
  {
    title: 'Usuários',
    path: '/users',
    icon: <Iconify icon={'mdi:account-multiple'} />,
    role: ['admin'],
  },
  {
    category: 'MENU',
    role: ['admin', 'user'],
  },
  {
    title: 'Categorias',
    path: '/categories',
    icon: <Iconify icon={'mdi:document'} />,
    role: ['admin', 'user'],
  },
  {
    title: 'Produtos',
    path: '/products',
    icon: <Iconify icon={'mdi:advertisements'} />,
    role: ['admin', 'user'],
  },
  // {
  //   title: 'Destaques',
  //   path: '/dashboard/spaces',
  //   icon: <Iconify icon={'ic:outline-screenshot-monitor'} />,
  //   role: ['admin', 'user'],
  // },
];

export default navConfig;
